import { Text } from "atoms";
import { Close } from "@mui/icons-material";
import { Button, IconButton, Stack, TextField } from "@mui/material";
import Modal from "components/Modal";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectPagination } from "containers/StoresPage/slice/selectors";
import { IWarehouseIn } from "openapi/types";
import { WarehouseIn } from "utils/interfaces/interfaces";
import {
  createWarehouse,
  updateWarehouse,
} from "containers/WarehousesPage/slice";
import { ModalContentWrapper } from "./atoms/ModalContentWrapper";

interface IWarehouseModalProps {
  onClose: () => void;
  warehouse?: IWarehouseIn;
}

export const AddWarehouseModal = ({
  onClose,
  warehouse,
}: IWarehouseModalProps) => {
  const [selectedWarehouse, setSelectedWarehouse] = useState<IWarehouseIn>(
    new WarehouseIn(),
  );
  const pagination = useSelector(selectPagination);
  const dispatch = useDispatch();

  useEffect(() => {
    if (warehouse) {
      setSelectedWarehouse(warehouse);
    }
  }, []);

  const onAction = () => {
    if (warehouse) {
      dispatch(updateWarehouse({ warehouse: selectedWarehouse, pagination }));
    } else {
      dispatch(createWarehouse({ warehouse: selectedWarehouse, pagination }));
    }
    setSelectedWarehouse(new WarehouseIn());
    onClose();
  };

  const updateWarehouseVariables = (key: keyof IWarehouseIn, value) => {
    setSelectedWarehouse({
      ...selectedWarehouse,
      [key]: value,
    });
  };

  return (
    <Modal isVisible={true} onClose={onClose}>
      <ModalContentWrapper>
        <div style={{ display: "flex", justifyContent: "end" }}>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </div>
        <Stack gap="1rem" className="mt-3">
          <Text bold fontSize="20px" style={{ marginBottom: "2rem" }}>
            Informații producător
          </Text>
          <TextField
            size="small"
            label="Nume"
            fullWidth
            value={selectedWarehouse?.title ?? ""}
            onChange={(e) => {
              updateWarehouseVariables("title", e.target.value);
            }}
          />
          <TextField
            size="small"
            label="Adresa"
            fullWidth
            value={selectedWarehouse?.address?.address ?? ""}
            onChange={(e) => {
              updateWarehouseVariables("address", {
                ...selectedWarehouse.address,
                address: e.target.value,
              });
            }}
          />
          <TextField
            size="small"
            label="Oras"
            fullWidth
            value={selectedWarehouse?.address?.city ?? ""}
            onChange={(e) => {
              updateWarehouseVariables("address", {
                ...selectedWarehouse.address,
                city: e.target.value,
              });
            }}
          />
          <TextField
            size="small"
            label="Judet"
            fullWidth
            value={selectedWarehouse?.address?.county ?? ""}
            onChange={(e) => {
              updateWarehouseVariables("address", {
                ...selectedWarehouse.address,
                county: e.target.value,
              });
            }}
          />
          <TextField
            size="small"
            label="Tara"
            fullWidth
            value={selectedWarehouse?.address?.country ?? ""}
            onChange={(e) => {
              updateWarehouseVariables("address", {
                ...selectedWarehouse.address,
                country: e.target.value,
              });
            }}
          />
        </Stack>
        <div
          className="mt-3"
          style={{ display: "flex", justifyContent: "end" }}
        >
          <Button variant="contained" onClick={onAction}>
            {warehouse ? "Editeaza" : "Adauga"}
          </Button>
        </div>
      </ModalContentWrapper>
    </Modal>
  );
};
